import axiosPost from '../axiosPost';

export const usuarioContactoBOUpd = async (arg) => {
    let result;

    const { params } = arg

    const body = {
        "service": "UsuarioContactoBOUpd",
        "params": params ? params : {}
    }

    try {
        result = await axiosPost('Y', body, arg)
    } catch (err) {
        console.log(err)
    }

    if(result?.data){
        return result.data
    } else return result
}
